import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const AudioPlayerContext = createContext({
  currentId: null,
  play: async (_id, _el) => {},
  pause: (_id) => {},
  isPlaying: (_id) => false,
});

export function AudioPlayerProvider({ children }) {
  const [currentId, setCurrentId] = useState(null);
  const currentElRef = useRef(null);

  const pause = useCallback((id) => {
    try {
      if (currentElRef.current) {
        currentElRef.current.pause();
      }
      if (!id || id === currentId) {
        setCurrentId(null);
        currentElRef.current = null;
      }
    } catch {}
  }, [currentId]);

  const play = useCallback(async (id, el) => {
    try {
      if (!el) return;
      // Pause any currently playing audio
      if (currentElRef.current && currentElRef.current !== el) {
        try { currentElRef.current.pause(); } catch {}
      }
      currentElRef.current = el;
      setCurrentId(id);
      await el.play();
    } catch {}
  }, []);

  const isPlaying = useCallback((id) => {
    try {
      const el = currentElRef.current;
      if (!el) return false;
      if (currentId !== id) return false;
      return !el.paused;
    } catch { return false; }
  }, [currentId]);

  const value = useMemo(() => ({ currentId, play, pause, isPlaying }), [currentId, play, pause, isPlaying]);

  return (
    <AudioPlayerContext.Provider value={value}>
      {children}
    </AudioPlayerContext.Provider>
  );
}

export function useAudioPlayer() {
  return useContext(AudioPlayerContext);
}
